
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('.header__inline-menu [id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  const datailsElement = summary.closest('[id^="Details-"]');
  datailsElement.addEventListener('mouseover', (event) => {
    datailsElement.setAttribute('open', true);
  });

  datailsElement.addEventListener('mouseout', (event) => {
    datailsElement.removeAttribute('open');
  });

  summary.addEventListener('click', (event) => {
    event.preventDefault();
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

document.querySelectorAll('header-drawer [id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

function asyncVendorsLoad() {
  const scriptsToLoad = [
    {
      name: 'swiper',
      src: getShopifyLink('swiper.min.js'),
    },
  ];
  const tag = document.getElementsByTagName('script')[0];
  scriptsToLoad.forEach((s) => {
    const script = document.createElement('script');

    script.type = 'text/javascript';
    script.async = true;
    script.src = s.src;

    script.addEventListener('load', (e) => {
      window.vendors = window.vendors || [];
      window.vendors.push(s.name);
      document.dispatchEvent(new CustomEvent(`${s.name}.loaded`));
    });

    return tag.parentNode.insertBefore(script, tag);
  });
}

function serializeForm(form) {
  // Setup our serialized data
  const serialized = {}; // Loop through each field in the form

  for (let i = 0; i < form.elements.length; i++) {
    const field = form.elements[i]; // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields

    if (
      !field.name ||
      field.disabled ||
      field.type === 'file' ||
      field.type === 'reset' ||
      field.type === 'submit' ||
      field.type === 'button'
    )
      continue; // If a multi-select, get all selections

    if (field.type === 'select-multiple') {
      for (let n = 0; n < field.options.length; n++) {
        if (!field.options[n].selected) continue;
        serialized[field.name] = field.options[n].value;
      }
    } // Convert field data to a query string
    else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
      serialized[field.name] = field.value;
    }
  }

  return serialized;
}

function getShopifyLink(fileName, location = 'asset') {
  if (!window.links) {
    return;
  }

  const baseLink = window.links[location];

  return baseLink.replace('XXX.XXX', fileName);
}

function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || window.moneyFormat;

  function formatWithDelimiters(number) {
    const precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    const thousands = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';
    const decimal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);
    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const centsAmount = parts[1] ? `${decimal}<sup class="cents">${parts[1]}</sup>` : '';
    return number == 0 ? '0' + dollarsAmount + centsAmount : dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;

    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;

    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;

    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;

    // ingarden 2026-10-22: Formate der EN-Maerkte SE/DK (SEK/DKK: "1 285,86 kr") und CH fehlten –
    // ohne diese Faelle blieb der Betrag leer (Side Cart zeigte nur " kr").
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', ',');
      break;

    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ', ',');
      break;

    case 'amount_with_period_and_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;

    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'", '.');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

function updateCart(body) {
  return fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } }).then((response) => {
    return response.json();
  });
}

function addToCart(body) {
  return fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } }).then((response) => {
    return response.json();
  });
}

function fetchCart() {
  return fetch(`${routes.cart_url}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', Accept: `application/json` },
  }).then((response) => {
    return response.json();
  });
}

function getSectionContent(sections) {
  return fetch(`${canonicalUrl}?sections=${sections}`, {
    method: 'GET',
  }).then((response) => {
    return response.json();
  });
}

function getSectionInnerHTML(html, selector) {
  return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
}

function getSectionDOM(html, selector) {
  return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
}

function getDateFromToday(days) {
  return new Date(new Date().setDate(new Date().getDate() + days));
}

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    detailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event) : this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

    this.menuDrawerOverlay = document.getElementById('menu-drawer-overlay');
    this.menuDrawerOverlay.addEventListener('click', this.closeMenuDrawer.bind(this));
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();

    this.loadContent.bind(this);
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    // window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = true;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    if (this.sliderLastItem.clientWidth > 0) {
      this.slideScrollPosition =
        event.currentTarget.name === 'next'
          ? this.slider.scrollLeft + step * this.sliderLastItem.clientWidth
          : this.slider.scrollLeft - step * this.sliderLastItem.clientWidth;
      this.slider.scrollTo({
        left: this.slideScrollPosition,
      });
    }
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      const productElement = document.querySelector('.product');

      if (
        productElement &&
        (productElement.classList.contains('ingarden-geschenkkarte') || productElement.classList.contains('keramik-bowl-ersatzteil'))
      ) {
        console.log(window.variantStrings.addToCartGiftCard);
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

// class VariantRadios extends VariantSelects {
//   constructor() {
//     super();
//   }

//   updateOptions() {
//     const fieldsets = Array.from(this.querySelectorAll('fieldset'));
//     this.options = fieldsets.map((fieldset) => {
//       return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
//     });
//   }
// }

class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.sellingPlanData = this.getSellingPlanData();
  }

  connectedCallback() {
    this.updateOptions();
    this.updateMasterId();
    this.updateSellingPlan();
    this.updatePrice();
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.updateSellingPlan();
      this.updatePrice();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value;
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => this.options[index] === option).includes(false);
    });
  }

  getSellingPlanData() {
    const dataElement = document.getElementById('selling-plans-data');
    return dataElement ? JSON.parse(dataElement.textContent).variants : [];
  }

  updateSellingPlan() {
    if (!this.currentVariant) return;

    const sellingPlansDataElement = document.getElementById('selling-plans-data');
    if (!sellingPlansDataElement) return;

    const sellingPlansData = JSON.parse(sellingPlansDataElement.textContent);

    const sellingPlan = sellingPlansData.variants.find((plan) => plan.variant_id === this.currentVariant.id);
    if (!sellingPlan || sellingPlan.selling_plan_id === 'null') return;

    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      let sellingPlanHiddenInput = productForm.querySelector('input[name="selling_plan"]');

      if (!sellingPlanHiddenInput) {
        sellingPlanHiddenInput = document.createElement('input');
        sellingPlanHiddenInput.type = 'hidden';
        sellingPlanHiddenInput.name = 'selling_plan';
        productForm.appendChild(sellingPlanHiddenInput);
      }

      sellingPlanHiddenInput.value = sellingPlan.selling_plan_id;
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    if (mediaGallery) {
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
    }

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (modalContent) {
      const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
      if (newMediaModal) {
        modalContent.prepend(newMediaModal);
      }
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));

      const sellingPlansDataElement = document.getElementById('selling-plans-data');
      if (!sellingPlansDataElement) return;

      const sellingPlansData = JSON.parse(sellingPlansDataElement.textContent);
      const sellingPlan = sellingPlansData.variants.find((plan) => plan.variant_id === this.currentVariant.id);

      if (!sellingPlan || sellingPlan.selling_plan_id === 'null') return;

      let sellingPlanHiddenInput = productForm.querySelector('input[name="selling_plan"]');
      if (!sellingPlanHiddenInput) {
        sellingPlanHiddenInput = document.createElement('input');
        sellingPlanHiddenInput.type = 'hidden';
        sellingPlanHiddenInput.name = 'selling_plan';
        productForm.appendChild(sellingPlanHiddenInput);
      }

      sellingPlanHiddenInput.value = sellingPlan.selling_plan_id;
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability ) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updatePrice() {
    if (!this.currentVariant) return;

    const addToCartButton = document.querySelector('.product-form__submit span');
    const basePrice = this.currentVariant.price;

    let subscriptionPrice = null;

    if (this.currentVariant.selling_plan_allocations.length > 0) {
      subscriptionPrice = this.currentVariant.selling_plan_allocations[0].price || 0;
    }

    const originalButtonText = window.variantStrings.addToCartGiftCard;
    let priceText =
      subscriptionPrice && subscriptionPrice < basePrice ? `${(subscriptionPrice / 100).toFixed(2)}` : `${(basePrice / 100).toFixed(2)}`;
    const formatPriceText = formatMoney(priceText);

    addToCartButton.innerHTML =  `<span>${formatPriceText}</span> – ${originalButtonText}`;
  }

  toggleAddButton(disable = true, text = '', modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (!this.currentVariant) {
      addButton.setAttribute('disabled', 'disabled');
      addButtonText.textContent = window.variantStrings.unavailable;
      return;
    }

    if (!this.currentVariant.available) {
      addButton.setAttribute('disabled', 'disabled');
      addButtonText.textContent = window.variantStrings.soldOut;
      return;
    }

    let sellingPlanPrice = null;
    if (this.currentVariant.selling_plan_allocations.length > 0) {
      sellingPlanPrice = this.currentVariant.selling_plan_allocations[0].price;
    }

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');

      const originalButtonText = window.variantStrings.addToCartGiftCard;

      let priceText =
        sellingPlanPrice && sellingPlanPrice < this.currentVariant.price
          ? `${(sellingPlanPrice / 100).toFixed(2)}`
          : `${(this.currentVariant.price / 100).toFixed(2)}`;

      const formatPriceText = formatMoney(priceText);
      addButtonText.innerHTML =  `<span>${formatPriceText}</span> – ${originalButtonText}`;
    }

    if (!modifyClass) return;
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm && typeof productForm.handleErrorMessage === 'function') {
      productForm.handleErrorMessage();
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove('visibility-hidden');

        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button?.querySelector('[name="add"]');
    const addButtonText = button?.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-radios', VariantRadios);

class CustomSlider extends HTMLElement {
  constructor() {
    super();
    this.sliderElement = this.querySelector('.swiper-container');
    this.slides = this.querySelectorAll('.swiper-slide');

    this.buttonPrev = this.querySelector('.swiper-button-prev');
    this.buttonNext = this.querySelector('.swiper-button-next');
    this.pagination = this.querySelector('.swiper-pagination');
    this.scrollbar = this.querySelector('.swiper-scrollbar');

    this.slider = null;

    const optionsJSONHTML = this.querySelector('[data-slider-options-json]');
    this.json = optionsJSONHTML ? JSON.parse(optionsJSONHTML.innerHTML) : {};

    const destroy = window.matchMedia(this.json.destroy);
    const minSlides = this.json.minSlides || 1;
    if (this.sliderElement && this.slides.length >= minSlides && destroy.matches === false) {
      this.loadSlider();
    }

    if (destroy.media !== 'undefined') destroy.onchange = (e) => (e.matches ? this.slider.destroy() : this.loadSlider());
  }

  loadSlider() {
    if (window.vendors && window.vendors.includes('swiper')) {
      this.initSlider();
    } else {
      document.addEventListener('swiper.loaded', () => {
        this.initSlider();
      });
    }
  }

  initSlider() {
    this.slider = new Swiper(
      this.sliderElement,
      Object.assign({}, this.json.options, {
        navigation: {
          nextEl: this.buttonNext,
          prevEl: this.buttonPrev,
        },
        pagination: {
          el: this.pagination,
        },
        scrollbar: {
          el: this.scrollbar,
          draggable: true,
        },
        on: {
          init: () => {
            if (this.buttonNext) {
              this.buttonNext.style.visibility = 'visible';
            }
            if (this.buttonPrev) {
              this.buttonPrev.style.visibility = 'visible';
            }
          },
        },
      })
    );
  }
}

customElements.define('custom-slider', CustomSlider);

class ButtonToTop extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', function(e) {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    });
  }
}

customElements.define('button-to-top', ButtonToTop);

class CartKitItem extends HTMLElement {
  constructor() {
    super();

    this.toggleVariantList = this.querySelector('[data-toggle]');
    this.inititalVariant = this.querySelector('input:checked');
    this.removeButton = this.querySelector('[data-remove]');

    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener('change', this.onVariantChange.bind(this));
    this.removeButton.addEventListener('click', this.onVariantRemove.bind(this));
  }

  async onVariantChange(event) {
    const body = JSON.stringify({
      updates: {
        [this.inititalVariant.dataset.variant]: this.inititalVariant.dataset.quantity - 1,
        [event.target.dataset.variant]: Number(event.target.dataset.quantity) + 1,
      },
    });

    this.onToggleSwitcher();
    // add loading

    await updateCart(body);
    window.dispatchEvent(new Event('cart:updated'), { bubbles: true });
    // remove loading when handle event
  }

  async onVariantRemove() {
    document.querySelector('button[data-checkout]').setAttribute('disabled', true);
    const cartData = await fetchCart();
    const cartItems = cartData.items;
    let updates = {};
    cartItems.forEach((item) => {
      updates[item.id] = 0;
    });
    const body = JSON.stringify({ updates });

    await updateCart(body);
    location.reload();
  }

  onToggleSwitcher(event) {
    if (this.classList.contains('active')) {
      this.classList.remove('active');
      this.toggleVariantList.textContent = this.toggleVariantList.dataset.edit;
    } else {
      this.classList.add('active');
      this.toggleVariantList.textContent = this.toggleVariantList.dataset.close;
    }
  }
}

customElements.define('cart-kit-item', CartKitItem);

class AddKitItem extends HTMLElement {
  constructor() {
    super();

    this.toggleButton = this.querySelector('[data-toggle]');
    this.modalElement = this.querySelector('[data-modal]');
    this.addToCartButton = this.querySelector('[data-add]');

    this.bindEvents();
  }

  bindEvents() {
    this.toggleButton.addEventListener('click', () => this.classList.add('active'));
    this.addToCartButton && this.addToCartButton.addEventListener('click', this.onAddToCartButtonClick.bind(this));
  }

  async onAddToCartButtonClick(event) {
    event.preventDefault();

    let selectedVariant = this.querySelector('input:checked');
    const body = JSON.stringify({
      items: [
        {
          id: +selectedVariant.dataset.variant,
          quantity: 1,
        },
      ],
    });

    await addToCart(body);
    window.dispatchEvent(new Event('cart:updated'));
  }
}

customElements.define('add-kit-item', AddKitItem);

class CartItem extends HTMLElement {
  constructor() {
    super();

    this.addButton = this.querySelector('[data-add-button]');
    this.quantityElement = this.querySelector('quantity-input');
    this.quantityInput = this.querySelector('quantity-input input');

    this.addButton && this.addButton.addEventListener('click', this.onAddButtonClick.bind(this));
    this.quantityElement && this.quantityInput.addEventListener('change', this.onChangeQuantity.bind(this));
  }

  onAddButtonClick(event) {
    this.quantityElement.querySelector('[name="plus"]').click();
  }

  toggleControls() {
    // this.addButton.classList.toggle('hidden');
    // this.quantityElement.classList.toggle('hidden');
  }

  onChangeQuantity(event) {
    if (this.quantityInput.value == 0) this.toggleControls();
  }
}

customElements.define('cart-item', CartItem);

class DrawerCart extends HTMLElement {
  constructor() {
    super();

    // handle cart item quantity changes in the drawer cart
    // handle subscription changes
    // likewise cart page logic
  }
}

customElements.define('drawer-cart', DrawerCart);
/* password eye */

const eyeVisibale = document.querySelector('.eye_visibale');
const password = document.querySelector('#RegisterForm-password');

eyeVisibale &&
  eyeVisibale.addEventListener('click', (e) => {
    const inputType = password.getAttribute('type') === 'password' ? 'text' : 'password';
    password.setAttribute('type', inputType);

    eyeVisibale.classList.toggle('close_eye');
  });

document.addEventListener('click', (evt) => {
  if (evt.target.closest('[data-slidecart-trigger]') && typeof SLIDECART_OPEN === 'function') {
    evt.preventDefault();
    SLIDECART_OPEN();
  }
});

class SubscriptionWidget extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      purchaseOption: '.subscription-widget__radio-input',
      sellingPlansDropdown: '.subscription-widget__selling-plans',
      padPrice: '.pad-price',
    };

    const form = this.closest('form');
    this.productFroms = form ? [form] : document.querySelectorAll(`form[data-productid="${this.dataset.productId}"]`);
    this.padPrice = this.querySelector(this.selectors.padPrice);

    this.setupEventListeners();
    this.updateSubscription();
  }

  setupEventListeners() {
    this.addEventListener('change', (event) => {
      if (event.target.closest(this.selectors.purchaseOption) || event.target.closest(this.selectors.sellingPlansDropdown)) {
        this.updateSubscription();
      }
    });
  }

  updateSubscription() {
    const purchaseOptionActive = this.querySelector(`${this.selectors.purchaseOption}:checked`);

    if (purchaseOptionActive?.value === 'subscription') {
      const sellingPlansDropdown = this.querySelector(this.selectors.sellingPlansDropdown);
      this.changeSellingPlanId(sellingPlansDropdown?.value);
      if (this.padPrice) {
        this.padPrice.innerHTML = this.padPrice.dataset.subscribe;
      }
    } else {
      this.changeSellingPlanId('');
      if (this.padPrice) {
        this.padPrice.innerHTML = this.padPrice.dataset.onetime;
      }
    }
  }

  changeSellingPlanId(sellingPlanId) {
    this.productFroms.forEach((form) => {
      const sellingPlanInput = form?.querySelector('[name="selling_plan"]');

      if (sellingPlanInput) {
        sellingPlanInput.value = sellingPlanId;
      } else {
        form.prepend(this.createSellingPlanInput(sellingPlanId));
      }
    });
  }

  createSellingPlanInput(value) {
    const input = document.createElement('input');
    input.name = 'selling_plan';
    input.type = 'hidden';
    input.value = value;

    return input;
  }
}
customElements.define('subscription-widget', SubscriptionWidget);
